import { render, staticRenderFns } from "./Fence-Module.vue?vue&type=template&id=2d7959fc&scoped=true"
import script from "./Fence-Module.vue?vue&type=script&lang=js"
export * from "./Fence-Module.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7959fc",
  null
  
)

export default component.exports